import { SuiteManifest } from '../manifest';
import { dataRoutes } from './routes';
import { dataNavItems } from './nav';

export const dataManifest: SuiteManifest = {
  id: 'data',
  name: 'Data & Integration',
  basePath: '/data',
  icon: 'shuffle',
  description: 'Data & Integration suite modules and operations.',
  requiredPermission: 'data.read',
  nav: dataNavItems,
  routes: dataRoutes,
};

export default dataManifest;
